import {getSessionStorageItem, setSessionStorageItem} from '@Utils/session-storage.util';

const TEMPLATES_TOOLTIP_SEEN_CACHE_KEY = 'pmw_aiPromptBoxTemplatesTooltipSeen';

export const hasUserSeenAiPromptBoxTemplatesTooltip = async (): Promise<boolean> => {
  if (!window.PMW.isUserLoggedIn()) {
    return false;
  }

  const cached = getSessionStorageItem(TEMPLATES_TOOLTIP_SEEN_CACHE_KEY);
  if (typeof cached === 'boolean') {
    return cached;
  }

  let hasSeen: boolean;
  try {
    hasSeen = (await window.PMW.readLocal('ai/hasUserSeenAiPromptBoxTemplatesTooltip')) as boolean;
  } catch (error) {
    console.error(error);
    return false;
  }
  setSessionStorageItem(TEMPLATES_TOOLTIP_SEEN_CACHE_KEY, hasSeen);
  return hasSeen;
};

export const markAiPromptBoxTemplatesTooltipAsSeen = async (): Promise<void> => {
  if (!window.PMW.isUserLoggedIn()) {
    return;
  }

  setSessionStorageItem(TEMPLATES_TOOLTIP_SEEN_CACHE_KEY, true);
  try {
    await window.PMW.writeLocal('ai/markAiPromptBoxTemplatesTooltipAsSeen');
  } catch (error) {
    console.error(error);
  }
};
